import createStore from 'unistore';

const Store = createStore({
  isLoading: true,
  distributionData: false,
  additionalData: false,
  compareData: false,
  infoboxContent: false,
  overallKey: 'Gesamtbevölkerung',
  compareKey: 'Haushalt.Paare ohne Kinder',
  tooltipKey: 'Gesamtbevölkerung',
  householdIncome: 3042,
  householdMembersAbove14: 2,
  householdMembersBelow14: 0,
  tooltipX: 0,
  tooltipY: 0,
  tooltipVisible: false,
});

export default Store;
